import { getPlatformKbDomain } from './plan-limits'

const RESERVED_SUBDOMAINS = new Set(['app', 'www', 'knowledge', 'support', 'api'])

function extractSlugFromDomain(hostname: string, domain: string): string | null {
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return null
  }

  if (hostname.endsWith('.localhost')) {
    const slug = hostname.slice(0, -'.localhost'.length)
    if (slug && !RESERVED_SUBDOMAINS.has(slug)) return slug
    return null
  }

  const suffix = `.${domain}`
  if (hostname.endsWith(suffix)) {
    const slug = hostname.slice(0, -suffix.length)
    if (slug && !slug.includes('.') && !RESERVED_SUBDOMAINS.has(slug)) return slug
    return null
  }

  return null
}

/** @deprecated Use getPlatformKbDomain() */
export function getKbPublicDomain() {
  if (import.meta.env.DEV) {
    return 'localhost:5173'
  }
  return getPlatformKbDomain()
}

export function getPublicKbUrl(slug: string) {
  if (import.meta.env.DEV) {
    return `http://${slug}.localhost:5173/knowledge`
  }
  return `https://${slug}.${getPlatformKbDomain()}/knowledge`
}

export function extractWorkspaceSlugFromHost(hostname: string): string | null {
  const host = hostname.split(':')[0].toLowerCase()
  return extractSlugFromDomain(host, getPlatformKbDomain())
}

export function getWorkspaceSlugFromHost(): string | null {
  if (typeof window === 'undefined') return null
  return extractWorkspaceSlugFromHost(window.location.hostname)
}

export function isPublicKbHost(): boolean {
  return getWorkspaceSlugFromHost() !== null
}

export function getPublicApiHeaders(): Record<string, string> {
  const slug = getWorkspaceSlugFromHost()
  if (!slug) return {}
  return { 'X-Workspace-Slug': slug }
}
